'use client'
var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);

// src/theme/theme.ts
import { extendTheme } from "@chakra-ui/react";
import { theme as baseTheme } from "@saas-ui/react";

// src/theme/foundations/typography.ts
var typography_exports = {};
__export(typography_exports, {
  fontSizes: () => fontSizes,
  fonts: () => fonts,
  textStyles: () => textStyles
});
var fonts = {
  heading: '"Inter Variable", InterVariable, Inter, sans-serif',
  body: '"Inter Variable", InterVariable, Inter, sans-serif'
};
var fontSizes = {
  xs: "0.75rem",
  sm: "0.8125rem",
  md: "0.875rem",
  lg: "1rem",
  xl: "1.125rem",
  "2xl": "1.5rem",
  "3xl": "1.875rem",
  "4xl": "2.25rem",
  "5xl": "3rem",
  "6xl": "3.75rem",
  "7xl": "4.5rem",
  "8xl": "6rem",
  "9xl": "8rem"
};
var textStyles = {
  h1: {
    fontSize: ["4xl", null, "6xl"],
    fontWeight: "extrabold",
    lineHeight: "1.2",
    letterSpacing: "-2%"
  },
  h2: {
    fontSize: ["36px", "48px"],
    fontWeight: "bold",
    lineHeight: "110%",
    letterSpacing: "-1%"
  },
  h3: {
    fontSize: ["lg", "xl"],
    fontWeight: "semibold",
    lineHeight: "110%",
    letterSpacing: "-1%"
  },
  subtitle: {
    fontSize: ["lg", null, "2xl"],
    fontWeight: "normal"
  }
};

// src/theme/components/active-filters-list.ts
var active_filters_list_default = {
  defaultProps: {
    variant: "page-filters"
  },
  variants: {
    "page-filters": {
      px: 4,
      py: 2,
      borderBottomWidth: "1px"
    },
    plain: {}
  },
  sizes: {
    sm: {
      px: 2,
      py: 1
    },
    md: {
      px: 4,
      py: 2
    },
    lg: {
      px: 6,
      py: 3
    }
  }
};

// src/theme/components/app-shell.ts
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
var parts = ["container", "inner", "main"];
var { defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts);
var appShellTheme = defineMultiStyleConfig({
  defaultProps: {
    variant: "fullscreen"
  },
  variants: {
    static: {
      minHeight: "100%"
    },
    fullscreen: {
      container: {
        position: "absolute",
        inset: 0
      }
    }
  }
});
var app_shell_default = appShellTheme;

// src/theme/components/aside.ts
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers2 } from "@chakra-ui/styled-system";
var parts2 = ["container", "headerWrapper", "header", "title", "body"];
var { definePartsStyle, defineMultiStyleConfig: defineMultiStyleConfig2 } = createMultiStyleConfigHelpers2(parts2);
var baseStyle = definePartsStyle({
  container: {
    display: "flex",
    flexDirection: "column",
    minH: 0,
    position: "relative"
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "stretch",
    minH: 12,
    borderBottomWidth: "1px",
    "& > .saas-toolbar": {
      ms: 4
    }
  },
  title: {
    fontWeight: "medium"
  },
  body: {
    flex: 1,
    overflow: "auto"
  }
});
var aside_default = defineMultiStyleConfig2({
  defaultProps: {
    size: "md"
  },
  baseStyle,
  sizes: {
    md: {
      header: {
        p: 4
      },
      title: {
        fontSize: "md"
      },
      body: {
        p: 4
      }
    },
    lg: {
      header: {
        p: 6
      },
      title: {
        fontSize: "lg"
      },
      body: {
        p: 6
      }
    }
  }
});

// src/theme/components/banner.ts
import {
  createMultiStyleConfigHelpers as createMultiStyleConfigHelpers3,
  defineStyle
} from "@chakra-ui/styled-system";
var { definePartsStyle: definePartsStyle2, defineMultiStyleConfig: defineMultiStyleConfig3 } = createMultiStyleConfigHelpers3(["container"]);
var variantFloating = definePartsStyle2((props) => {
  const { colorScheme: c } = props;
  let containerStyles = defineStyle({
    bg: `${c}.500`
  });
  if (c === "gray") {
    containerStyles = defineStyle({
      bg: "gray.300",
      _dark: {
        bg: "gray.500"
      }
    });
  }
  return {
    container: {
      top: "auto",
      bottom: "40px",
      boxShadow: "md",
      borderRadius: "lg",
      maxW: "container.lg",
      left: 0,
      right: 0,
      marginLeft: "auto",
      marginRight: "auto",
      ...containerStyles
    }
  };
});
var bannerTheme = defineMultiStyleConfig3({
  variants: {
    floating: variantFloating
  }
});

// src/theme/components/beacon.ts
import { keyframes } from "@emotion/react";
var pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  55% {
    transform: scale(1.6);
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
`;
var baseStyle2 = (props) => {
  const { colorScheme: c } = props;
  return {
    bg: `${c}.400`,
    borderRadius: "full",
    h: "4",
    w: "4",
    _before: {
      content: '""',
      display: "block",
      w: "4",
      h: "4",
      borderRadius: "full",
      animation: `${pulse} 1s ease-in-out infinite`,
      boxShadow: "0 0 2px 2px",
      color: `${c}.400`
    }
  };
};
var beacon_default = {
  defaultProps: {
    colorScheme: "primary",
    size: "sm"
  },
  baseStyle: baseStyle2,
  sizes: {
    xs: {
      h: "1",
      w: "1",
      _before: {
        h: "1",
        w: "1"
      }
    },
    sm: {
      h: "2",
      w: "2",
      _before: {
        h: "2",
        w: "2"
      }
    },
    md: {
      h: "3",
      w: "3",
      _before: {
        h: "3",
        w: "3"
      }
    },
    lg: {
      h: "4",
      w: "4",
      _before: {
        h: "4",
        w: "4"
      }
    }
  }
};

// src/theme/components/button.ts
import { defineStyle as defineStyle2 } from "@chakra-ui/styled-system";
import { transparentize } from "@chakra-ui/theme-tools";
var variantGhost = defineStyle2((props) => {
  const { colorScheme: c } = props;
  if (c === "gray") {
    return {
      borderColor: "default-border-color",
      _checked: {
        bg: "blackAlpha.200",
        _dark: {
          bg: "whiteAlpha.300"
        }
      }
    };
  }
  return variantOutline(props);
});
var variantOutline = defineStyle2((props) => {
  const { colorScheme: c, theme: theme2 } = props;
  return {
    _checked: {
      bg: `${c}.100`,
      _dark: {
        bg: transparentize(`${c}.200`, 0.12)(theme2)
      }
    }
  };
});
var variantSecondary = defineStyle2((props) => {
  const { colorScheme: c, theme: theme2 } = props;
  return {
    ...theme2.components.Button.variants.outline(props),
    bg: "transparent",
    _checked: {
      bg: `${c}.100`,
      _dark: {
        bg: transparentize(`${c}.200`, 0.12)(theme2)
      }
    }
  };
});
var sizes = {
  xs: defineStyle2({
    h: "7",
    minW: "7",
    fontSize: "xs",
    px: "2"
  })
};
var button_default = {
  variants: {
    ghost: variantGhost,
    outline: variantOutline,
    secondary: variantSecondary
  },
  sizes
};

// src/theme/components/card.ts
var card_default = {
  baseStyle: {
    container: {
      _checked: {
        boxShadow: "outline"
      }
    }
  }
};

// src/theme/components/command.ts
var command_default = {
  baseStyle: {
    fontSize: "xs",
    "[role=tooltip] > &": {
      ms: 1,
      _before: {
        content: '"\u2022"',
        me: 1,
        fontSize: "xs"
      }
    }
  }
};

// src/theme/components/data-grid.ts
import {
  createMultiStyleConfigHelpers as createMultiStyleConfigHelpers4,
  defineCssVars
} from "@chakra-ui/styled-system";
import { transparentize as transparentize2 } from "@chakra-ui/theme-tools";
var parts3 = [
  "container",
  "inner",
  "table",
  "thead",
  "tbody",
  "tfoot",
  "tr",
  "th",
  "title",
  "resizer",
  "td",
  "caption"
];
var { defineMultiStyleConfig: defineMultiStyleConfig4, definePartsStyle: definePartsStyle3 } = createMultiStyleConfigHelpers4(parts3);
var vars = defineCssVars("data-grid", [
  "bg",
  "row-bg",
  "row-hover-bg",
  "row-selected-bg"
]);
var pinnedLeftStyles = {
  position: "sticky",
  left: "var(--pinned-left)",
  zIndex: 1,
  bg: vars["row-bg"].reference,
  "&[data-last]:after": {
    content: '""',
    display: "block",
    position: "absolute",
    right: "-4px",
    zIndex: 1,
    top: "-1px",
    bottom: "-1px",
    width: "4px",
    pointerEvents: "none",
    bgGradient: "linear(to-r, blackAlpha.200, transparent)"
  },
  _before: {
    content: '""',
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: -1,
    pointerEvents: "none"
  },
  _dark: {
    "&[data-last]:after": {
      my: "1px",
      borderLeft: "1px solid",
      borderColor: "inherit",
      bgGradient: "linear(to-r, blackAlpha.300, transparent)"
    }
  }
};
var pinnedRightStyles = {
  position: "sticky",
  right: "var(--pinned-right)",
  zIndex: 1,
  bg: vars.bg.reference,
  opacity: 0.95,
  "&[data-last]:after": {
    content: '""',
    position: "absolute",
    left: "-4px",
    zIndex: 1,
    top: "-1px",
    bottom: "-1px",
    width: "4px",
    pointerEvents: "none",
    bgGradient: "linear(to-l, blackAlpha.200, transparent)"
  },
  _before: {
    content: '""',
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: -1,
    pointerEvents: "none"
  },
  _dark: {
    "&[data-last]:after": {
      my: "1px",
      borderRight: "1px solid",
      borderColor: "inherit",
      bgGradient: "linear(to-r, blackAlpha.300, transparent)"
    }
  }
};
var baseStyle3 = definePartsStyle3({
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    height: "100%",
    maxWidth: "100%",
    position: "relative",
    [vars.bg.variable]: "colors.chakra-body-bg",
    [vars["row-bg"].variable]: "colors.chakra-body-bg",
    [vars["row-hover-bg"].variable]: "inherit",
    [vars["row-selected-bg"].variable]: "inherit"
  },
  inner: {
    height: "100%",
    width: "100%",
    overflow: "auto"
  },
  table: {
    display: "grid",
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse"
  },
  thead: {
    display: "grid",
    "&[data-sticky]": {
      position: "sticky",
      top: 0,
      zIndex: 2,
      bg: vars.bg.reference
    }
  },
  tbody: {
    display: "grid"
  },
  th: {
    display: "flex",
    position: "relative",
    alignItems: "center",
    fontWeight: "medium",
    textAlign: "start",
    padding: 0,
    "&[data-pinned=left]": pinnedLeftStyles,
    "&[data-pinned=right]": pinnedRightStyles
  },
  title: {
    display: "flex",
    flex: 1,
    '&[aria-sort="none"] svg': {
      opacity: 0,
      transitionProperty: "opacity",
      transitionDuration: "normal"
    },
    '&[aria-sort="none"]:hover svg, &[aria-sort="none"]:focus-visible svg': {
      opacity: 1
    },
    "[data-is-numeric=true] &": {
      textAlign: "end",
      justifyContent: "end"
    },
    _focusVisible: {
      outlineColor: "primary.400",
      outlineOffset: "-2px"
    }
  },
  resizer: {
    position: "absolute",
    right: "-8px",
    zIndex: 1,
    visibility: "hidden",
    width: "20px",
    height: "100%",
    userSelect: "none",
    cursor: "col-resize",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "blackAlpha.300",
    "&:hover, &:active": {
      color: "primary.500",
      visibility: "visible"
    },
    _dark: {
      color: "whiteAlpha.300",
      "&:hover, &:active": {
        color: "primary.500"
      }
    },
    _before: {
      content: '""',
      display: "block",
      width: "2px",
      height: "18px",
      cursor: "col-resize",
      bg: "currentColor",
      transitionProperty: "all",
      transitionDuration: "normal"
    },
    "th:hover &": {
      visibility: "visible"
    }
  },
  tr: {
    bg: vars["row-bg"].reference,
    display: "flex",
    width: "full",
    position: "relative",
    _hover: {
      bg: vars["row-hover-bg"].reference
    },
    _selected: {
      bg: vars["row-selected-bg"].reference
    },
    _focusVisible: {
      outline: "none",
      _after: {
        content: '""',
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        bg: "transparent",
        zIndex: 1,
        pointerEvents: "none",
        boxShadow: "inset 0 0 0 2px var(--chakra-colors-primary-400)"
      }
    }
  },
  td: {
    display: "flex",
    alignItems: "center",
    textAlign: "start",
    _focus: {
      outline: "none",
      boxShadow: "inset 0 0 0 2px var(--chakra-colors-primary-400)"
    },
    "&[data-pinned=left]": pinnedLeftStyles,
    "&[data-pinned=right]": pinnedRightStyles,
    "&[data-is-numeric=true]": {
      textAlign: "end",
      justifyContent: "end"
    }
  },
  caption: {
    mt: 4,
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "medium"
  }
});
var variantSimple = definePartsStyle3((props) => {
  const { colorScheme: c, theme: theme2 } = props;
  return {
    th: {
      color: "gray.600",
      borderBottom: "1px",
      borderColor: "blackAlpha.200",
      _dark: {
        color: "gray.400",
        borderColor: "whiteAlpha.100"
      }
    },
    caption: {
      color: "gray.600",
      _dark: {
        color: "gray.400"
      }
    },
    td: {
      borderBottom: "1px",
      borderColor: "blackAlpha.200",
      _dark: {
        borderColor: "whiteAlpha.100"
      },
      "&[data-range-selected]": {
        bg: "primary.50",
        _dark: {
          bg: transparentize2(`${c}.500`, 0.1)(theme2)
        }
      }
    },
    tbody: {
      "tr[data-interactive]:hover": {
        "& [data-focused]:before": {
          boxShadow: "inset 0 0 0 2px var(--chakra-colors-primary-400)"
        },
        "& [data-pinned]:before": {
          bg: vars["row-hover-bg"].reference
        },
        [vars["row-hover-bg"].variable]: "colors.gray.50",
        _dark: {
          [vars["row-hover-bg"].variable]: "colors.whiteAlpha.50"
        }
      },
      "tr[data-selected]": {
        "& [data-pinned]:before": {
          bg: vars["row-selected-bg"].reference
        },
        [vars["row-selected-bg"].variable]: `colors.${c}.50`,
        borderColor: `${c}.100`,
        _dark: {
          [vars["row-selected-bg"].variable]: transparentize2(
            `${c}.500`,
            0.1
          )(theme2),
          borderColor: transparentize2(`${c}.500`, 0.2)(theme2)
        },
        "&[data-interactive]:hover": {
          "& [data-pinned]:before": {
            bg: vars["row-selected-bg"].reference
          },
          [vars["row-selected-bg"].variable]: `colors.${c}.100`,
          _dark: {
            [vars["row-selected-bg"].variable]: transparentize2(
              `${c}.500`,
              0.2
            )(theme2)
          }
        }
      },
      "tr:last-of-type": {
        border: 0
      }
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: { borderBottomWidth: 0 }
        }
      }
    }
  };
});
var variantStriped = definePartsStyle3((props) => {
  const styles2 = variantSimple(props);
  return {
    ...styles2,
    tbody: {
      "tr:nth-of-type(odd)": {
        [vars["row-bg"].variable]: "colors.gray.50",
        _dark: {
          "& [data-pinned]": {
            bg: vars["bg"].reference
          },
          "& [data-pinned]:before": {
            bg: vars["row-bg"].reference
          },
          [vars["row-bg"].variable]: "colors.whiteAlpha.50",
          _selected: {
            "& [data-pinned]:before": {
              bg: vars["row-selected-bg"].reference
            }
          }
        }
      },
      ...styles2.tbody
    }
  };
});
var sizes2 = definePartsStyle3({
  sm: {
    title: {
      px: "3",
      py: "2",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "3",
      py: "2",
      fontSize: "sm",
      lineHeight: "4"
    },
    caption: {
      px: "3",
      py: "2",
      fontSize: "xs"
    }
  },
  md: {
    title: {
      px: "4",
      py: "3",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "4",
      py: "3",
      lineHeight: "4"
    },
    caption: {
      px: "4",
      py: "2",
      fontSize: "sm"
    }
  },
  lg: {
    title: {
      px: "6",
      py: "4",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "6",
      py: "4",
      lineHeight: "5"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "sm"
    }
  },
  xl: {
    title: {
      px: "8",
      py: "5",
      lineHeight: "5",
      fontSize: "sm"
    },
    td: {
      px: "8",
      py: "5",
      lineHeight: "6"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "md"
    }
  }
});
var dataGridTheme = defineMultiStyleConfig4({
  baseStyle: baseStyle3,
  sizes: sizes2,
  variants: {
    simple: variantSimple,
    striped: variantStriped,
    unstyled: {}
  },
  defaultProps: {
    variant: "simple",
    size: "md",
    colorScheme: "primary"
  }
});
var data_grid_default = dataGridTheme;

// src/theme/components/data-grid-pagination.ts
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers5 } from "@chakra-ui/styled-system";
var { defineMultiStyleConfig: defineMultiStyleConfig5 } = createMultiStyleConfigHelpers5(["container"]);
var data_grid_pagination_default = defineMultiStyleConfig5({
  defaultProps: {
    size: "sm"
  },
  baseStyle: {
    container: {
      display: "flex",
      flexDirection: "row"
    }
  },
  sizes: {
    xs: {
      container: {
        fontSize: "xs",
        px: 2,
        py: 1
      }
    },
    sm: {
      container: {
        fontSize: "sm",
        px: 4,
        py: 2
      }
    }
  }
});

// src/theme/components/empty-state.ts
var variantNoResults = () => {
  return {
    body: {
      display: "flex",
      flexDirection: "column",
      textAlign: "center",
      alignItems: "center"
    },
    actions: {
      mt: 2
    }
  };
};
var empty_state_default = {
  defaultProps: {
    variant: "centered"
  },
  variants: {
    "no-results": variantNoResults
  },
  sizes: {
    xs: {
      title: {
        fontSize: "xs",
        mt: 2
      }
    },
    sm: {
      title: {
        fontSize: "sm",
        mt: 2
      }
    }
  }
};

// src/theme/components/form.ts
var Input = {
  variants: {
    outline: {
      field: {
        "::placeholder": {
          color: "muted"
        }
      }
    }
  }
};
var form_default = {
  Input,
  NumberInput: Input,
  PinInput: Input,
  Select: Input
};

// src/theme/components/kbd.ts
import { mode } from "@chakra-ui/theme-tools";
var variantSolid = (props) => {
  return {
    bg: mode("blackAlpha.200", "whiteAlpha.300")(props),
    color: mode("blackAlpha.700", "whiteAlpha.800")(props),
    borderWidth: 0,
    borderBottomWidth: 0,
    padding: "1px",
    display: "inline-block",
    borderRadius: "3px",
    minW: "20px",
    textAlign: "center",
    fontSize: "sm",
    mr: 1,
    ":last-child": {
      mr: 0
    }
  };
};
var kbd_default = {
  defaultProps: {
    variant: "solid"
  },
  variants: {
    basic: {
      opacity: 0.6
    },
    solid: variantSolid
  }
};

// src/theme/components/nav-group.ts
var nav_group_default = {
  baseStyle: {
    title: {
      color: "sidebar-muted",
      "&.saas-collapse-toggle": {
        cursor: "pointer",
        borderRadius: "md",
        _hover: {
          bg: "sidebar-on-muted"
        }
      }
    }
  }
};

// src/theme/components/nav-item.ts
var nav_item_default = {
  baseStyle: {
    item: {
      color: "sidebar-text"
    },
    link: {
      color: "sidebar-text",
      _hover: {
        bg: "sidebar-on-muted"
      }
    },
    icon: {
      color: "sidebar-muted",
      ".sui-nav-item [data-active] &, .sui-nav-item:not([data-active]):hover &": {
        color: "sidebar-text"
      }
    }
  },
  variants: {
    neutral: {
      link: {
        _hover: {
          bg: "sidebar-on-muted"
        },
        _active: {
          bg: "sidebar-on-subtle"
        }
      }
    }
  }
};

// src/theme/components/page.ts
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers6 } from "@chakra-ui/styled-system";
var parts4 = [
  "container",
  "headerContainer",
  "header",
  "heading",
  "headerFooter",
  "title",
  "description",
  "body"
];
var { definePartsStyle: definePartsStyle4, defineMultiStyleConfig: defineMultiStyleConfig6 } = createMultiStyleConfigHelpers6(parts4);
var baseStyle4 = definePartsStyle4({
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minH: 0
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "stretch",
    px: 4,
    minH: 14
  },
  headerFooter: {
    py: 2,
    px: 4
  },
  title: {
    fontWeight: "semibold",
    fontSize: "md"
  },
  description: {
    color: "muted",
    fontSize: "sm"
  },
  body: {
    flex: 1,
    overflowY: "auto",
    p: 4,
    "& > div": {
      margin: "0 auto",
      minHeight: "100%",
      height: "1px"
      // hack to make sure the Loader 100% height is working
    }
  }
});
var variantDefault = definePartsStyle4({
  header: {
    ps: 4,
    borderBottomWidth: "1px"
  },
  headerFooter: {
    borderBottomWidth: "1px"
  },
  title: {
    me: 4
  }
});
var variantDefaultSidebar = definePartsStyle4({
  header: {
    ps: { base: 14, lg: 4 },
    borderBottomWidth: "1px"
  },
  headerFooter: {
    borderBottomWidth: "1px"
  },
  title: {
    me: 4
  }
});
var variantPlain = definePartsStyle4({
  header: {
    ps: 4
  },
  title: {
    me: 4,
    fontSize: "xl"
  }
});
var variantHero = definePartsStyle4((props) => {
  const { colorScheme: c } = props;
  return {
    headerContainer: {
      bg: `${c}.500`
    },
    header: {
      flexDirection: "column",
      alignItems: "flex-start",
      borderBottomWidth: 0,
      maxW: "container.xl",
      margin: "0 auto",
      p: { base: 8, lg: 14 }
    },
    title: {
      fontSize: "2xl",
      color: "white"
    },
    description: {
      fontSize: "lg",
      color: "whiteAlpha.700",
      mb: 4
    },
    body: {
      p: { base: 8, lg: 14 }
    }
  };
});
var variantSettings = definePartsStyle4({
  container: {
    overflowY: "auto",
    px: 4
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    maxW: "container.xl",
    margin: "0 auto",
    mb: {
      base: 4,
      lg: 8
    },
    minH: 24,
    p: 0
  },
  heading: {
    py: {
      base: 4,
      lg: 8
    }
  },
  title: {
    fontSize: "2xl"
  },
  description: {
    fontSize: "md"
  },
  body: {
    overflow: "visible",
    p: 0
  }
});
var page_default = defineMultiStyleConfig6({
  defaultProps: {
    variant: "default",
    colorScheme: "gray"
  },
  baseStyle: baseStyle4,
  variants: {
    default: variantDefault,
    "default-sidebar": variantDefaultSidebar,
    hero: variantHero,
    settings: variantSettings,
    plain: variantPlain
  }
});

// src/theme/components/property.ts
var property_default = {
  baseStyle: {
    label: {
      color: "muted"
    }
  }
};

// src/theme/components/radio-card.ts
import {
  cssVar,
  defineStyle as defineStyle3,
  defineStyleConfig
} from "@chakra-ui/styled-system";
import { get } from "@chakra-ui/utils";
import { transparentize as transparentize3 } from "polished";
var $bg = cssVar("card-bg");
var $paddingY = cssVar("card-padding-y");
var $paddingX = cssVar("card-padding-x");
var $shadow = cssVar("card-shadow");
var $radius = cssVar("card-radius");
var $border = cssVar("card-border-width", "0");
var $borderColor = cssVar("card-border-color");
var $outlineColor = cssVar(
  "card-outline-color",
  "var(--chakra-colors-primary-500)"
);
var baseStyle5 = defineStyle3(({ theme: theme2 }) => ({
  background: $bg.reference,
  borderColor: $borderColor.reference,
  borderWidth: $border.reference,
  borderRadius: $radius.reference,
  boxShadow: $shadow.reference,
  py: $paddingY.reference,
  px: $paddingX.reference,
  [$outlineColor.variable]: "colors.primary.500",
  position: "relative",
  textAlign: "start",
  transitionProperty: "common",
  transitionDuration: "normal",
  _before: {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: $radius.reference,
    pointerEvents: "none"
  },
  _checked: {
    outline: "2px solid",
    outlineOffset: "-2px",
    outlineColor: $outlineColor.reference
  },
  _focusVisible: {
    outline: "none",
    _before: {
      bg: transparentize3(0.95, get(theme2, "colors.primary.500"))
    }
  }
}));
var variantElevated = defineStyle3(() => {
  return {
    [$bg.variable]: "colors.white",
    [$borderColor.variable]: "colors.blackAlpha.200",
    [$border.variable]: "1px",
    [$shadow.variable]: "shadows.sm",
    _dark: {
      [$bg.variable]: "colors.whiteAlpha.200",
      [$borderColor.variable]: "colors.whiteAlpha.50"
    },
    _hover: {
      [$borderColor.variable]: "colors.blackAlpha.300",
      _dark: {
        [$borderColor.variable]: "colors.whiteAlpha.300"
      }
    }
  };
});
var variantOutline2 = defineStyle3(() => {
  return {
    [$border.variable]: "1px",
    [$shadow.variable]: "none",
    [$borderColor.variable]: "colors.blackAlpha.200",
    [$bg.variable]: "transparent",
    _hover: {
      [$borderColor.variable]: "colors.blackAlpha.300"
    },
    _dark: {
      [$borderColor.variable]: "colors.whiteAlpha.300",
      _hover: {
        [$borderColor.variable]: "colors.whiteAlpha.300"
      }
    }
  };
});
var sizes3 = {
  sm: defineStyle3({
    [$radius.variable]: "radii.md",
    [$paddingY.variable]: "space.2",
    [$paddingX.variable]: "space.3"
  }),
  md: defineStyle3({
    [$radius.variable]: "radii.md",
    [$paddingY.variable]: "space.3",
    [$paddingX.variable]: "space.4"
  }),
  lg: defineStyle3({
    [$radius.variable]: "radii.lg",
    [$paddingY.variable]: "space.4",
    [$paddingX.variable]: "space.6"
  })
};
var radioCardTheme = defineStyleConfig({
  defaultProps: {
    colorScheme: "primary",
    variant: "outline",
    size: "md"
  },
  baseStyle: baseStyle5,
  variants: {
    elevated: variantElevated,
    outline: variantOutline2
  },
  sizes: sizes3
});

// src/theme/components/section.ts
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers7 } from "@chakra-ui/styled-system";
var parts5 = ["container", "header", "title", "description", "body"];
var { definePartsStyle: definePartsStyle5, defineMultiStyleConfig: defineMultiStyleConfig7 } = createMultiStyleConfigHelpers7(parts5);
var baseStyle6 = definePartsStyle5({
  title: {
    fontSize: ["lg", "xl"],
    fontWeight: "semibold",
    lineHeight: "110%",
    letterSpacing: "-1%",
    mb: 1
  },
  description: {
    color: "muted",
    fontSize: "md",
    a: {
      fontWeight: "medium",
      color: "app-text"
    }
  }
});
var variantDefault2 = definePartsStyle5({
  container: {
    flexDirection: "column"
  },
  header: {
    mb: 4
  }
});
var variantAnnotated = definePartsStyle5({
  container: {
    flexDirection: ["column", null, "row"],
    mt: 4
  },
  header: {
    width: ["full", null, "30%"],
    mt: 0,
    mb: [4, null, 0],
    pe: [4, null, 8]
  }
});
var section_default = defineMultiStyleConfig7({
  defaultProps: {
    variant: "default"
  },
  baseStyle: baseStyle6,
  variants: {
    default: variantDefault2,
    annotated: variantAnnotated
  }
});

// src/theme/components/sidebar.ts
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers8 } from "@chakra-ui/styled-system";
var parts6 = ["container", "overlay", "section", "toggleWrapper", "toggle"];
var { definePartsStyle: definePartsStyle6, defineMultiStyleConfig: defineMultiStyleConfig8 } = createMultiStyleConfigHelpers8(parts6);
var baseStyle7 = definePartsStyle6((props) => {
  const { colorScheme: c } = props;
  const bg = c ? `${c}.500` : "sidebar-background";
  return {
    container: {
      bg,
      color: "sidebar-text",
      "&, & *, & *::before, & &::after": {
        borderColor: "sidebar-border-color"
      },
      _dark: {
        bg
      }
    }
  };
});
var sidebar_default = defineMultiStyleConfig8({
  baseStyle: baseStyle7
});

// src/theme/components/split-page.ts
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers9 } from "@chakra-ui/styled-system";
var parts7 = ["container", "content"];
var { definePartsStyle: definePartsStyle7, defineMultiStyleConfig: defineMultiStyleConfig9 } = createMultiStyleConfigHelpers9(parts7);
var baseStyle8 = definePartsStyle7({
  container: {
    position: "relative",
    overflow: "hidden"
  },
  content: {
    bg: "app-background",
    display: "flex",
    flex: 1,
    height: "100%"
  }
});
var split_page_default = defineMultiStyleConfig9({
  defaultProps: {
    variant: "default",
    colorScheme: "gray"
  },
  baseStyle: baseStyle8
});

// src/theme/components/stepper.ts
var variantDots = (props) => {
  const { colorScheme: c } = props;
  return {
    stepper: {
      alignItems: "center",
      justifyContent: "center"
    },
    step: {
      flex: 0
    },
    indicator: {
      overflow: "hidden",
      textIndent: "-9999px",
      width: "8px",
      height: "8px",
      border: 0,
      bg: "gray.200",
      _dark: {
        bg: "whiteAlpha.400"
      },
      '[data-status="active"] &': {
        bg: c ? `${c}.500` : "black",
        _dark: {
          bg: c ? `${c}.500` : "white"
        }
      },
      '[data-status="complete"] &': {
        bg: c ? `${c}.500` : "black",
        _dark: {
          bg: c ? `${c}.500` : "white"
        }
      }
    },
    title: {
      display: "none"
    },
    description: {
      display: "none"
    },
    separator: {
      display: "none"
    },
    icon: {
      display: "none"
    }
  };
};
var stepper_default = {
  variants: {
    dots: variantDots
  }
};

// src/theme/components/tabs.ts
import { tabsAnatomy as parts8 } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers10 } from "@chakra-ui/styled-system";
var { definePartsStyle: definePartsStyle8 } = createMultiStyleConfigHelpers10(parts8.keys);
var variantSegments = definePartsStyle8((props) => {
  const { theme: theme2 } = props;
  return {
    tablist: {
      display: "flex",
      rounded: "md",
      alignItems: "center"
    },
    tab: {
      ...theme2.components.Button.baseStyle,
      ...theme2.components.Button.variants.ghost(props),
      borderWidth: "1px",
      borderColor: "gray.200",
      color: "muted",
      rounded: 0,
      position: "relative",
      "&:not(:last-of-type)": {
        marginEnd: "-1px"
      },
      _dark: {
        borderColor: "whiteAlpha.300",
        _hover: {}
      },
      _first: {
        borderLeftRadius: "md",
        borderRightRadius: 0
      },
      _last: {
        borderRightRadius: "md",
        borderLeftRadius: 0
      },
      _hover: {
        color: "black",
        zIndex: 1,
        borderColor: "gray.300",
        bg: "gray.50",
        _dark: {
          color: "white",
          borderColor: "whiteAlpha.400",
          bg: "whiteAlpha.50"
        }
      },
      _selected: {
        ...theme2.components.Button.variants.secondary(props),
        borderColor: "gray.300",
        bg: "gray.50",
        _dark: {
          color: "white",
          borderColor: "whiteAlpha.400",
          bg: "whiteAlpha.50"
        },
        zIndex: 1,
        _hover: {},
        _active: {}
      }
    }
  };
});
var variantSegmentsSolid = definePartsStyle8((props) => {
  const { theme: theme2 } = props;
  return {
    tablist: {
      display: "inline-flex",
      rounded: "lg",
      alignItems: "center",
      bg: "gray.100",
      _dark: {
        bg: "whiteAlpha.100"
      }
    },
    tab: {
      ...theme2.components.Button.baseStyle,
      ...theme2.components.Button.variants.ghost(props),
      color: "muted",
      borderWidth: "1px",
      borderColor: "transparent",
      rounded: "md",
      fontWeight: "normal",
      _hover: {
        color: "black",
        _dark: {
          color: "white"
        }
      },
      _selected: {
        ...theme2.components.Button.variants.solid(props),
        bg: "white",
        boxShadow: "sm",
        borderColor: "default-border-color",
        _dark: {
          color: "white",
          bg: "gray.900"
        },
        zIndex: 1,
        _hover: {},
        _active: {}
      }
    }
  };
});
var sizes4 = {
  xs: definePartsStyle8({
    tab: {
      fontSize: "sm",
      h: 7,
      py: 0,
      px: 2
    }
  }),
  sm: definePartsStyle8({
    tab: {
      fontSize: "sm",
      h: 8,
      py: 0,
      px: 2
    }
  }),
  md: definePartsStyle8({
    tab: {
      h: 9,
      py: 0,
      px: 4
    }
  }),
  lg: definePartsStyle8({
    tab: {
      h: 10,
      py: 0,
      px: 4
    }
  })
};
var tabs_default = {
  defaultProps: {
    colorScheme: "gray",
    size: "sm"
  },
  variants: {
    segments: variantSegments,
    "segments-solid": variantSegmentsSolid
  },
  sizes: sizes4
};

// src/theme/components/tag.ts
import { tagAnatomy as parts9 } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as createMultiStyleConfigHelpers11, cssVar as cssVar2 } from "@chakra-ui/styled-system";
var { definePartsStyle: definePartsStyle9, defineMultiStyleConfig: defineMultiStyleConfig10 } = createMultiStyleConfigHelpers11(parts9.keys);
var $fg = cssVar2("badge-color");
var outlineVariant = definePartsStyle9((props) => {
  const { colorScheme: c } = props;
  if (c === "gray") {
    return {
      container: {
        _dark: {
          [$fg.variable]: "colors.gray.700",
          color: "gray.500"
        }
      }
    };
  }
  return {};
});
var solidVariant = definePartsStyle9((props) => {
  const { colorScheme: c } = props;
  if (c === "gray") {
    return {
      container: {
        bg: "blackAlpha.100",
        color: "gray.600",
        _dark: {
          bg: "whiteAlpha.100",
          color: "gray.400"
        }
      }
    };
  }
  return {};
});
var plainVariant = definePartsStyle9({
  container: {
    borderColor: "default-border-color",
    borderWidth: "1px",
    color: "muted"
  }
});
var tag_default = defineMultiStyleConfig10({
  defaultProps: {
    variant: "solid"
  },
  baseStyle: {
    container: {
      borderRadius: "full"
    }
  },
  variants: {
    plain: plainVariant,
    outline: outlineVariant,
    solid: solidVariant
  }
});

// src/theme/components/toolbar.ts
var toolbar_default = {
  defaultProps: {
    variant: "ghost",
    size: "sm"
  }
};

// src/theme/components/tooltip.ts
import { defineStyleConfig as defineStyleConfig2 } from "@chakra-ui/styled-system";
var tooltip_default = defineStyleConfig2({
  baseStyle: {
    py: 1,
    borderRadius: "base",
    borderColor: "gray.300",
    _dark: {
      borderColor: "whiteAlpha.300"
    }
  }
});

// src/theme/components/index.ts
var components = {
  SuiAppShell: app_shell_default,
  SuiActiveFiltersList: active_filters_list_default,
  SuiBanner: bannerTheme,
  SuiBeacon: beacon_default,
  SuiCommand: command_default,
  SuiEmptyState: empty_state_default,
  SuiNavGroup: nav_group_default,
  SuiNavItem: nav_item_default,
  SuiPage: page_default,
  SuiSplitPage: split_page_default,
  SuiAside: aside_default,
  SuiProperty: property_default,
  SuiSection: section_default,
  SuiSidebar: sidebar_default,
  SuiDataGrid: data_grid_default,
  SuiDataGridPagination: data_grid_pagination_default,
  SuiToolbar: toolbar_default,
  SuiRadioCard: radioCardTheme,
  Button: button_default,
  Card: card_default,
  Form: form_default,
  Kbd: kbd_default,
  Tabs: tabs_default,
  Tag: tag_default,
  Tooltip: tooltip_default,
  Stepper: stepper_default,
  ...form_default
};

// src/theme/foundations/semantic-tokens.ts
var tokens = {
  colors: {
    "app-background": {
      default: "white",
      _dark: "gray.900"
    },
    "app-text": {
      default: "blackAlpha.900",
      _dark: "whiteAlpha.900"
    },
    "sidebar-background": {
      default: "white",
      _dark: "gray.900"
    },
    "sidebar-border-color": {
      default: "default-border-color"
    },
    "sidebar-on": {
      default: "blackAlpha.300",
      _dark: "whiteAlpha.300"
    },
    "sidebar-on-muted": {
      default: "blackAlpha.100",
      _dark: "whiteAlpha.100"
    },
    "sidebar-on-subtle": {
      default: "blackAlpha.200",
      _dark: "whiteAlpha.200"
    },
    "sidebar-text": {
      default: "app-text"
    },
    "sidebar-muted": {
      default: "muted"
    },
    "default-border-color": {
      default: "blackAlpha.200",
      _dark: "whiteAlpha.200"
    },
    muted: {
      default: "blackAlpha.600",
      _dark: "whiteAlpha.700"
    },
    "chakra-body-bg": "app-background",
    "chakra-body-text": "app-text",
    "page-body-bg-subtle": {
      default: "gray.50",
      _dark: "none"
    }
  }
};
var semantic_tokens_default = tokens;

// src/theme/styles.ts
var styles = {
  global: () => ({
    body: {
      color: "app-text",
      bg: "app-background",
      fontSize: "sm"
    },
    "*::placeholder": {
      color: "muted"
    },
    "*, *::before, &::after": {
      borderColor: "default-border-color",
      wordWrap: "break-word"
    }
  })
};
var styles_default = styles;

// src/theme/theme.ts
var theme = extendTheme(
  {
    components,
    semanticTokens: semantic_tokens_default,
    styles: styles_default,
    ...typography_exports
  },
  baseTheme
);

export {
  __privateGet,
  __privateAdd,
  __privateSet,
  theme
};
//# sourceMappingURL=chunk-MQD3SWK3.mjs.map